import CampusAmbassadorDetails from "./Campus_Ambassador/CampusAmbassador_Details";
import DataShowcase from "./Campus_Ambassador/Data";
import CampusAmbassadorForm from "./Campus_Ambassador/CampusAmbassadorForm";
import "./Css/campus_ambassador.css";

function CampusAmbassador() {
  return (
    <div>
      <CampusAmbassadorDetails />
      <DataShowcase />
      <CampusAmbassadorForm />
    </div>
  );
}

export default CampusAmbassador;
